import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AppLayout, PageHeader } from "@/components/Layout";
import { Building2, Globe, Star } from "lucide-react";

const SponsorCard = ({ s, index }) => (
  <div data-testid={`sponsor-card-${s.id}`}
    className={`flex gap-3 rounded-xl border bg-card p-4 shadow-sm animate-fade-up ${s.featured ? "border-secondary/50 ring-1 ring-secondary/20" : "border-border"}`}
    style={{ animationDelay: `${Math.min(index, 12) * 40}ms` }}>
    <div className="grid h-16 w-16 shrink-0 place-items-center overflow-hidden rounded-lg bg-muted">
      {s.logo ? (
        <img src={s.logo} alt={s.name} className="h-full w-full object-contain p-1" />
      ) : (
        <span className="grid h-full w-full place-items-center bg-primary/10 text-primary"><Building2 size={22} /></span>
      )}
    </div>
    <div className="flex-1">
      <div className="flex items-center gap-2">
        <h3 className="font-display text-lg font-bold leading-tight text-primary">{s.name}</h3>
        {s.featured && <Star size={14} className="fill-secondary text-secondary" />}
      </div>
      {s.level && <p className="text-xs font-bold uppercase tracking-wider text-secondary">{s.level}</p>}
      {s.description && <p className="mt-1 text-sm text-foreground/80">{s.description}</p>}
      {s.website && (
        <a href={s.website} target="_blank" rel="noreferrer"
          className="mt-1.5 inline-flex items-center gap-1 text-xs font-semibold text-primary underline underline-offset-2">
          <Globe size={12} /> Visit Website
        </a>
      )}
    </div>
  </div>
);

export default function Sponsors() {
  const [sponsors, setSponsors] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/sponsors").then((r) => setSponsors(r.data)).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  const named = sponsors.filter((s) => s.name);

  return (
    <AppLayout>
      <PageHeader subtitle="With Thanks To" title="Our Sponsors" />
      <div className="space-y-3 px-4 pt-2" data-testid="sponsors-page">
        {loaded && named.length === 0 && (
          <div className="rounded-xl border border-dashed border-border bg-card/50 p-6 text-center">
            <Building2 size={30} className="mx-auto text-muted-foreground/40" />
            <p className="mt-3 text-sm text-muted-foreground" data-testid="sponsors-empty">
              Sponsor partners will be announced soon. Interested in sponsoring the Bluegrass Mustang Makeover? Reach out to the event team.
            </p>
          </div>
        )}
        {named.map((s, i) => <SponsorCard key={s.id} s={s} index={i} />)}
      </div>
    </AppLayout>
  );
}
